
import { Vue, Component, Prop } from 'vue-property-decorator';
import ShopService from '@/services/shop.service';
import lazyInject from '@/di';
import { AuthEnum } from '@/services/permission.service';
import CarService from '@/services/car.service';

@Component
export default class RevisionRecordTable extends Vue {
  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(CarService)
  carService!: CarService;

  @Prop()
  carShopCode!: string;

  AuthEnum = AuthEnum;

  columns = [
    {
      title: '修改属性',
      dataIndex: 'update_desc',
      key: 'update_desc',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'update_desc' },
    },
    {
      title: '操作人ID',
      dataIndex: 'user_id',
      key: 'user_id',
      align: 'center',
      width: '100px',
    },
    {
      title: '操作人姓名',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
      width: '100px',
    },
    {
      title: '提交时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
      width: '160px',
    },
    {
      title: '处理状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '备注',
      dataIndex: 'audit_remark',
      key: 'audit_remark',
      align: 'center',
      width: '200px',
    },
    {
      title: '工单编号',
      dataIndex: 'work_order_no',
      key: 'work_order_no',
      align: 'center',
      width: '250px',
      scopedSlots: { customRender: 'work_order_no' },
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: '100px',
      scopedSlots: { customRender: 'action' },
    },
  ];

  data = [];
  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  shopId = '';
  created() {
    this.shopId = this.$route.params.id;
    // this.init();
  }

  copyToClipboard(item: any) {
    this.$copyText(String(item)).then(
      () => {
        this.$message.success('复制成功');
      },
      (err) => {
        this.$message.error(`复制失败:${err}`);
      },
    );
  }
  async init() {
    const { current, pageSize } = this.pagination;
    const pac = {
      page: current,
      pageSize,
    };
    const data: any = await this.carService.carShopUpdateRecordList(
      this.carShopCode,
      pac,
    );
    if (data) {
      this.pagination.current = data.page;
      this.pagination.total = data.total;
      this.data = data.list;
    }
  }

  captureOrderNo(text: any) {
    if (!text) return '';
    const result = `${text.substring(0, 10) }......${ text.substring(text.length - 6)}`;
    return result;
  }

  async deleteItem(action: any) {
    this.$confirm({
      title: '提示',
      content: '确定要删除这条记录吗?',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const res = await this.carService.carShopUpdateRecordDeleteWorkOrder({
          work_order_id: action.id,
        });
        if (res) {
          this.$message.success(res);
          this.init();
        }
      },
      onCancel() {},
    });
  }

  async rePushItem(action: any) {
    const res = await this.carService.carShopUpdateRecordDelete({
      work_order_id: action.id,
    });
    if (res) {
      this.$message.success(res);
      this.init();
    }
  }

  async auditResult(action: any) {
    const params = {
      work_order_id: action.id,
    };
    const res = await this.carService.carShopUpdateRecordQueryWorkOrderStatus(
      params,
    );
    if (res) {
      let text: any;
      text = res.orderStateName;
      if (res.failReasonList && res.failReasonList.length > 0) {
        text = `${text}（${res.failReasonList[0]}）`;
      }
      this.$message.success(text);
      this.init();
    }
  }

  onChangePage(page: number) {
    this.pagination.current = page;
    this.init();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.init();
  }
}
